import { MapPin, X, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PILPlacementToolbarProps {
  isPlacing: boolean;
  onStart: () => void;
  onCancel: () => void;
}

export function PILPlacementToolbar({
  isPlacing,
  onStart,
  onCancel,
}: PILPlacementToolbarProps) {
  if (!isPlacing) {
    return (
      <Button size="sm" variant="outline" onClick={onStart}>
        <Plus className="size-3.5 mr-1.5" />
        Add installation spot
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2 rounded-lg border bg-background/95 backdrop-blur-sm px-3 py-2 shadow-lg">
      <MapPin className="size-4 text-primary" />
      <span className="text-xs font-medium text-muted-foreground">
        Click map to drop an installation spot
      </span>
      <Button size="sm" variant="ghost" onClick={onCancel}>
        <X className="size-3.5 mr-1" />
        Cancel
      </Button>
    </div>
  );
}
